module.exports = __webpack_public_path__ + "img/Mazda.7289b124.jpg";